import { IGenericJSON } from '../helpers/interface';

export class School {
  id: number;
  name: string;
  district_id: number;

  constructor(data: IGenericJSON) {
    this.id = data['id'];
    this.name = data['name'];
    this.district_id = data['district_id'];
  }

  public static digest(data: IGenericJSON): School {
    return new School(data);
  }

  public static digestResponse(data: IGenericJSON[]): School[] {
    const ret: School[] = [];
    data.forEach((u: IGenericJSON): void => {
      ret.push(this.digest(u));
    });
    return ret;
  }
}
